import React from "react";

export default function StatusPill({ statut, map }) {
  const cfg = map[statut] || { label: statut, cls: "pill-neutral" };
  return (
    <span className={`pill ${cfg.cls}`} data-testid={`pill-${statut}`}>
      {cfg.label}
    </span>
  );
}
